import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";
import { showApiErrorToast } from "../utils/helpers";

const fetchTrialDistinctForms = async ({ trialId }) => {
  const token = localStorage.getItem("token");

  const res = await axios.get(`${__API_URL__}/api/ecrf/trial/${trialId}/distinct-forms/`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data;
};

const useGetTrialDistinctForms = ({ trialId, enabled = true }) => {
  return useQuery({
    queryKey: ["trial_distinct_forms", trialId],
    queryFn: () => fetchTrialDistinctForms({ trialId }),
    enabled: enabled && Boolean(trialId),
    onError: (error) => {
      showApiErrorToast(error, "Failed to load trial forms");
    },
  });
};

export default useGetTrialDistinctForms;
